module.exports = __webpack_public_path__ + "img/020031.72046b9c.png";